/* eslint-disable no-case-declarations */
import { SET_LOGGED_IN_TOKEN } from '../../types/Types';

/** @type { Object } default state */
const defaultState = {
  idToken: null,
  accessToken: null,
};

/**
 * dispatched the user data to the store
 * @param  { Object } state  default state
 * @param  { Object } action dispacthed action from middleware
 */
export default function saveToken(state = defaultState, action = {}) {
  switch (action.type) {
    case SET_LOGGED_IN_TOKEN:
      const data = {};
      data.idToken = action.idToken;
      data.accessToken = action.accessToken;
      return { ...state, ...data };
    default: return state;
  }
}
